import { BaseFieldProps } from "./types";
import { get } from 'lodash';
import React from 'react';
import { useShowContextRequired } from "../Show";
import { useNewUiTheme } from '../newUiTheme';

export enum DateFormat {
  FULL,
  SHORT,
}

export interface DateFieldProps extends BaseFieldProps<Date> {
  format?: DateFormat,
  noValueText?: string
  prefix?: string
}

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function toDate(value: Date | string): Date {
  if (value instanceof Date) {
    return value;
  }
  const parts = value.split(/\D/) as unknown as number[];
  return new Date(parts[0], parts[1] - 1, parts[2]);
}

function getFullFormatView(date: Date) {
  return `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}

function getShortFormatView(date: Date) {
  const dd = String(date.getDate());
  const mm = String(date.getMonth() + 1);
  const yyyy = date.getFullYear()
    .toString()
    .substring(2);

  return `${mm}/${dd}/${yyyy}`;
}

export function DateField(props: DateFieldProps) {
  const context = useShowContextRequired();
  const uiTheme = useNewUiTheme();

  const format = props.format || DateFormat.FULL;

  let obj;
  if (props.source) {
    if (context.data) {
      obj = get(context.data, props.source);
    } else {
      obj = null;
    }
  } else {
    obj = props.value;
  }

  if (obj) {
    const date = toDate(obj);

    let result;

    if (format === DateFormat.FULL) {
      result = getFullFormatView(date);
    } else {
      result = getShortFormatView(date);
    }

    return (
      <uiTheme.fields.DateFieldLayout
        value={result}
        prefix={props.prefix}
        className={props.className}
        style={props.style}
        label={props.label}
        noDataMessage={props.noDataMessage}
      />
    );
  } else {
    return (
      <uiTheme.fields.DateFieldLayout
        value={undefined}
        noDataMessage={props.noValueText}
        className={props.className}
        style={props.style}
        label={props.label}
      />
    );
  }
}
